import { ref, toRaw } from "vue"

export default function useToggle(intValue: boolean | undefined = true) {
  const visible = ref(toRaw(intValue))

  function changeVisible(targetValue?: boolean): void {
    if (targetValue === undefined) {
      visible.value = !visible.value
    } else {
      visible.value = targetValue
    }
  }

  function show() {
    changeVisible(true)
  }

  function hide() {
    changeVisible(false)
  }

  return {
    visible,
    show,
    hide,
    changeVisible,
  }
}
